import { Pipe, PipeTransform } from '@angular/core';
import { ChargingUser } from 'src/app/features/charging-users/charging-user.model';

@Pipe({
  name: 'translateChargingUserAppUser',
})
export class TranslateChargingUserAppUserPipe implements PipeTransform {
  transform(chargingUser: ChargingUser): string {
    if (chargingUser.mokUserNumber) {
      return `Mok: ${chargingUser.mokUserNumber}`;
    } else if (chargingUser.deviceId) {
      return `Enheds-id: ${chargingUser.deviceId}`;
    } else if (chargingUser.appInvitationHasBeenSent) {
      return 'Inviteret';
    }
    return '';
  }
}
